import React from 'react';
import { Container, Typography, Paper } from '@mui/material';
import './LegalPages.css';

const GizlilikPolitikasi = () => {
  return (
    <Container maxWidth="md" className="legal-container">
      <Paper elevation={3} className="legal-paper">
        <Typography variant="h4" component="h1" gutterBottom>
          Gizlilik Politikası
        </Typography>

        <div className="section">
          <Typography variant="h6" className="section-title">
            1. Veri Toplama ve Kullanım
          </Typography>
          <Typography variant="body1" paragraph>
            HOPS olarak, hizmetlerimizi kullanırken sizden toplanan kişisel verilerin gizliliğini korumayı taahhüt ediyoruz. 
            Bu veriler arasında isim, e-posta adresi, telefon numarası ve şirket bilgileri bulunmaktadır.
          </Typography>
        </div>

        <div className="section">
          <Typography variant="h6" className="section-title">
            2. Veri Güvenliği
          </Typography>
          <Typography variant="body1" paragraph>
            Verileriniz, endüstri standardı güvenlik protokolleri ve şifreleme teknolojileri kullanılarak korunmaktadır. 
            Yetkisiz erişim, değiştirme veya ifşaya karşı uygun güvenlik önlemleri alınmaktadır.
          </Typography>
        </div>

        <div className="section">
          <Typography variant="h6" className="section-title">
            3. Veri Paylaşımı
          </Typography>
          <Typography variant="body1" paragraph>
            Kişisel verileriniz, yasal zorunluluklar dışında üçüncü taraflarla paylaşılmamaktadır. 
            Hizmet sağlayıcılarımızla yapılan veri paylaşımları, gizlilik sözleşmeleri kapsamında gerçekleştirilmektedir.
          </Typography>
        </div>

        <div className="section">
          <Typography variant="h6" className="section-title">
            4. Çerezler ve İzleme
          </Typography>
          <Typography variant="body1" paragraph>
            Platformumuzda, kullanıcı deneyimini iyileştirmek için çerezler kullanılmaktadır. 
            Bu çerezler, oturum bilgilerini ve kullanıcı tercihlerini saklamak için kullanılır.
          </Typography>
        </div>

        <div className="section">
          <Typography variant="h6" className="section-title">
            5. Kullanıcı Hakları
          </Typography>
          <Typography variant="body1" paragraph>
            KVKK kapsamında, kişisel verilerinize erişim, düzeltme, silme ve işleme itiraz etme haklarına sahipsiniz. 
            Bu haklarınızı kullanmak için bizimle iletişime geçebilirsiniz.
          </Typography>
        </div>

        <div className="contact-info">
          <Typography variant="h6" gutterBottom>
            İletişim Bilgileri
          </Typography>
          <Typography variant="body1">
            Gizlilik politikamız hakkında sorularınız için:
          </Typography>
          <Typography variant="body1">
            E-posta: info@hopssoftware.com
          </Typography>
          <Typography variant="body1">
            Telefon: +90 552 464 11 16
          </Typography>
        </div>
      </Paper>
    </Container>
  );
};

export default GizlilikPolitikasi; 